import {recordEvent,LinkType} from 'js/ts/tracking'

export default class ProductDetailTracking {

  constructor() {
    this.attachSupplierTableLinkTracking()
    this.attachRelatedDocumentsLinkTracking()
    this.attachTechnicalSpecsLinkTracking()
    this.attachCtaRecordProductImpression()
  }

  private attachSupplierTableLinkTracking(): void {
    $('section.product-suppliers a, section.product-suppliers gs-button, section.product-summary gs-button.download-datasheet').on("click", (e) => {
      const currentElement = $(e.currentTarget)
      const supplierRow = currentElement.closest(".supplier")
      const suppliersDiv = currentElement.closest(".product-suppliers")

      const linkText = currentElement.text().trim()
      const events = currentElement.data('events')
      const type = currentElement.data('type')
      const regRequired = currentElement.data('reg-required')
      const position = supplierRow.data('table-position')
      const status = supplierRow.data('status')
      const supplierId = supplierRow.data('id')
      const productNumber = supplierRow.data('product-number')
      const isCanonical = supplierRow.data('is-canonical')
      const supplierType = supplierRow.data('type')
      const channel = suppliersDiv.data('channel')
      const loggedIn = suppliersDiv.data('logged-in')
      const linkUrl = currentElement.attr("href")

      const trackingVariables = {
        channel: channel,
        eVar1: channel,
        eVar27: type,
        eVar47: status,
        eVar4: supplierId,
        prop3: supplierId,
        eVar82: isCanonical,
        eVar83: supplierType,
        eVar87: position,
        eVar95: productNumber,
        eVar12: loggedIn,
        prop9: loggedIn,
        prop1: linkUrl,
      }

      const linkType = regRequired ? LinkType.other : LinkType.exit

      if (events) {
        recordEvent(events, trackingVariables, linkText, linkType)
      }
    })
  }

  private attachRelatedDocumentsLinkTracking(): void {
    $('section.related-documents a').on("click", (e) => {
      const currentElement = $(e.currentTarget)

      const linkText = currentElement.text().trim()
      const events = currentElement.data('events')
      const type = currentElement.data('type')
      const supplierId = currentElement.data('id')
      const regRequired = currentElement.data('reg-required')

      const linkType = regRequired ? LinkType.other : LinkType.exit

      if (events) {
        recordEvent(events, {eVar27: type, eVar4: supplierId, prop3: supplierId}, linkText, linkType)
      }
    })
  }

  private attachTechnicalSpecsLinkTracking(): void {
    $('.unlock-specs').on("click", (e) => {
      recordEvent("event115", {}, "Unlock Full Spec")
    })
  }


	private attachCtaRecordProductImpression(): void {
		$("#supplier-table .supplier a, #supplier-table .supplier gs-button").on("click", (e) => {
			const supplier = $(e.target).closest('.supplier')
			const impressionIsAlreadyRecorded = supplier.data('is-first');
			// the first supplier already got its lead on page load
			if (impressionIsAlreadyRecorded) return;

			const context = "Part:" + supplier.data('name-number');
			const supplierId = supplier.data('id');

			const params = new URLSearchParams(window.location.search);
			const categoryId = params.get("comp");

			const args = {
				"method": "recordLead",
				"leadType": "Product1",
				"supplierId": supplierId,
				"categoryId": categoryId,
				"contextDesc": context
			};

			$.ajax({
				url: "/ajax/ProductSearch/RecordSupplierLead.cfc",
				type: "POST",
				data: args,
				async: false,
				timeout: 500,
				dataType: "json"
			});
		});
	}
}